<div class="ewallet-confirmation p-4">
  <h2 class="mb-4">{{ 'ewallet_confirm_title' | translate }}</h2>

  <!-- Order Summary -->
  <c-card class="payment-details mb-4 shadow-sm">
    <c-card-body>
      <div class="detail-row d-flex justify-content-between mb-3">
        <span>{{ 'ewallet_order_total' | translate }}</span>
        <strong>{{ totalPrice | currencyAmount: currency }}</strong>
      </div>

      @if (userBalance() > 0) {
        <div class="detail-row d-flex justify-content-between mb-3">
          <span>{{ 'ewallet_current_balance' | translate }}</span>
          <strong>{{ userBalance() | currencyAmount: currency }}</strong>
        </div>
      }

      @if (remainingBalance() > 0) {
        <div class="detail-row highlight d-flex justify-content-between">
          <span>{{ 'ewallet_remaining_balance' | translate }}</span>
          <strong class="text-primary">{{ remainingBalance() | currencyAmount: currency }}</strong>
        </div>
      }
    </c-card-body>
  </c-card>

  <!-- Error -->
  @if (error()) {
    <c-alert color="danger" class="mb-4">
      <svg cIcon name="cilExclamationCircle" class="me-2"></svg>
      {{ error() }}
    </c-alert>
  }

  <!-- Send Code Section -->
  @if (!codeSent()) {
    <c-card class="confirmation-section shadow-sm">
      <c-card-body class="text-center">
        <p class="mb-4">{{ 'ewallet_code_sent_notice' | translate }}</p>

        <button
          cButton
          color="primary"
          size="lg"
          class="w-100"
          (click)="sendConfirmationCode()"
          [disabled]="loading()"
        >
          @if (loading()) {
            <c-spinner size="sm" class="me-2"></c-spinner>
            {{ 'ewallet_sending' | translate }}
          } @else {
            <svg cIcon name="cilEnvelopeOpen" class="me-2"></svg>
            {{ 'ewallet_send_code' | translate }}
          }
        </button>
      </c-card-body>
    </c-card>
  }

  <!-- Code Entry Section -->
  @if (codeSent()) {
    <div class="code-entry-section">
      <c-alert color="info" class="d-flex align-items-center mb-4">
        <svg cIcon name="cilEnvelopeOpen" class="me-2"></svg>
        {{ 'ewallet_code_sent_to' | translate }} {{ userEmail() }}
      </c-alert>

      <c-card class="shadow-sm">
        <c-card-body>
          <p class="mb-3">{{ 'ewallet_enter_code' | translate }}</p>

          <div class="code-input-group mb-4">
            <input
              type="text"
              class="form-control form-control-lg text-center"
              maxlength="6"
              pattern="[0-9]*"
              [(ngModel)]="confirmationCode"
              placeholder="000000"
              (keyup.enter)="confirmPayment()"
              [disabled]="loading()"
            />
          </div>

          @if (expiresIn() > 0) {
            <div class="countdown text-center mb-4 text-body-secondary">
              <svg cIcon name="cilClock" class="me-2"></svg>
              {{ 'ewallet_code_expires' | translate }}
              <strong>{{ formattedTime() }}</strong>
            </div>
          } @else {
            <div class="text-center mb-4 text-danger">
              {{ 'ewallet_code_expired' | translate }}
            </div>
          }

          <button
            cButton
            color="success"
            size="lg"
            class="w-100 mb-3"
            (click)="confirmPayment()"
            [disabled]="!canConfirm()"
          >
            @if (loading()) {
              <c-spinner size="sm" class="me-2"></c-spinner>
              {{ 'ewallet_processing' | translate }}
            } @else {
              <svg cIcon name="cilCheckAlt" class="me-2"></svg>
              {{ 'ewallet_confirm_payment' | translate }}
            }
          </button>

          <button
            cButton
            color="secondary"
            variant="outline"
            class="w-100"
            (click)="resendCode()"
            [disabled]="loading()"
          >
            {{ 'ewallet_resend_code' | translate }}
          </button>
        </c-card-body>
      </c-card>
    </div>
  }

  <!-- Back Button -->
  <div class="wizard-actions mt-5">
    <button
      cButton
      color="secondary"
      class="w-100"
      (click)="goBack()"
      [disabled]="loading()"
    >
      <svg cIcon name="cilArrowLeft" class="me-2"></svg>
      {{ 'ewallet_back' | translate }}
    </button>
  </div>
</div>